import { gql } from "@apollo/client";

const ADD_PROJECT = gql`
    mutation addProject($name:String!,$description:String!,$status:ProjectStatus!,$clientId:ID!){
        addProject(name:$name,description:$description,status:$status,clientId:$clientId){
            id,
            name,
            description,
            status,
            client{
                id,
                name,
                phone,
                email
            }
        }
    }
`

const DELETE_PROJECT = gql`
    mutation deleteProject($id:ID!){
        deleteProject(id:$id){
            id,name
        }
    }
`

const UPDATE_PROJECT = gql`
    mutation updateProject($id:ID!,$name:String!,$description:String!,$status:ProjectStatusUpdate!){
        updateProject(id:$id,name:$name,description:$description,status:$status){
            id,
            name,
            description,
            status,
            client{
                id,
                name,
                phone,
                email
            }
        }
    }

`

export {ADD_PROJECT,UPDATE_PROJECT,DELETE_PROJECT}